export const NO_VALUE_LABEL = 'No value'

export interface RowGroup {
  key: string
  label: string
  rows: Record<string, unknown>[]
  count: number
  sums: Record<string, number>
}

interface GroupRowsOptions {
  labelFor?: (value: unknown, sampleRow: Record<string, unknown>) => string
  numericFields?: string[]
}

export function groupRows(
  rows: Record<string, unknown>[],
  field: string,
  { labelFor, numericFields = [] }: GroupRowsOptions = {},
): RowGroup[] {
  const byKey = new Map<string, RowGroup>()
  for (const row of rows) {
    const value = row[field]
    const isEmpty = value === null || value === undefined || value === ''
    const key = isEmpty ? '' : String(value)
    let group = byKey.get(key)
    if (!group) {
      group = {
        key,
        label: isEmpty ? NO_VALUE_LABEL : labelFor ? labelFor(value, row) : String(value),
        rows: [],
        count: 0,
        sums: {},
      }
      byKey.set(key, group)
    }
    group.rows.push(row)
    group.count += 1
    for (const nf of numericFields) {
      const raw = row[nf]
      if (raw === null || raw === undefined || raw === '') continue
      const num = typeof raw === 'number' ? raw : Number(raw)
      if (!Number.isNaN(num)) group.sums[nf] = (group.sums[nf] ?? 0) + num
    }
  }
  const groups = Array.from(byKey.values())
  groups.sort((a, b) => {
    if (a.key === '') return 1
    if (b.key === '') return -1
    return a.label.localeCompare(b.label)
  })
  return groups
}
